module.exports = __webpack_public_path__ + "img/lens-174-minus-09.bb2c4c75.png";